<template>
  <div class="app-wrapper" :class="classObj">
    <div v-if="device==='mobile'&&sidebar.opened" class="drawer-bg" @click="handleClickOutside"></div>
    <div class="sidebar-container">
      <!-- <el-row style="height: 50px; background-color: rgb(48, 65, 86);">
        <h3 style="margin-left: 50px; color: #fff; font-size: 15px;">LuxTag</h3>
      </el-row> -->
      <!-- <el-row style="display: block; height: 60px; background-color: #0972ce; flex-direction: row;">
        <h1 v-if="sidebar.opened" >BLOCKCHAIN</h1>
      </el-row> -->
      <el-row style="display: flex; height: 140px; background-color: #0972ce; flex-direction: row; justify-content: center; align-items:center;">
        <img v-if="sidebar.opened" class="logo" :src="logo">
        <!-- <h3 v-if="sidebar.opened" style="margin-left: 10px; margin-top: 22px; color: #fff; font-size: 15px;">LuxTag</h3> -->
      </el-row>
      <div style="border-bottom: 1px rgba(255,255,255,0.15) solid; margin-left: 20px; margin-right: 20px;">
        <el-row style="display: block; height: 55px; background-color: #0972ce; flex-direction: column; justify-content: center; align-items:center;">
          <h2 style="height: 8px;" v-if="sidebar.opened" >{{role}}</h2>
          <h2 style="color: rgba(255,255,255,0.7);" v-if="sidebar.opened" >{{email}}</h2>
        </el-row>
      </div>
      <sidebar style="margin-top: 20px;"></sidebar>
      <el-row style="width: 100%; height: 60px; background-color: #0972ce; position: absolute; justify-content: center; align-items: center; bottom: 0px;">
        <h2 v-if="sidebar.opened" style="display: flex; flex-direction: row; justify-content: center; text-align: center; ">Powered by <h2 @click="link" style="cursor: pointer; margin: 0px 0px 0px 3px; text-decoration: underline; color: #a5c4ff;">NEM Blockchain</h2></h2>
      </el-row>
    </div>
    <div class="main-container">
      <navbar></navbar>
      <app-main></app-main>
    </div>
  </div>
</template>

<script>
import { Navbar, Sidebar, AppMain } from './components'
import ResizeMixin from './mixin/ResizeHandler'
import logo from '@/assets/logo-luxtag.png'

export default {
  name: 'layout',
  components: {
    Navbar,
    Sidebar,
    AppMain
  },
  mixins: [ResizeMixin],
  computed: {
    sidebar() {
      return this.$store.state.app.sidebar
    },
    device() {
      return this.$store.state.app.device
    },
    email() {
      return this.$store.getters.email
    },
    role() {
      return this.$store.getters.role
    },
    classObj() {
      return {
        hideSidebar: !this.sidebar.opened,
        withoutAnimation: this.sidebar.withoutAnimation,
        mobile: this.device === 'mobile'
      }
    }
  },
  methods: {
    handleClickOutside() {
      this.$store.dispatch('CloseSideBar', { withoutAnimation: false })
    },
    link() {
      window.open('https://nem.io/')
    }
  },
  data() {
    return {
      logo
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "src/styles/mixin.scss";
  .sidebar-container {
    background-color: #0972ce;
  }
  .app-wrapper {
    @include clearfix;
    position: relative;
    height: 100%;
    width: 100%;
  }
  .drawer-bg {
    background: #000;
    opacity: 0.3;
    width: 100%;
    top: 0;
    height: 100%;
    position: absolute;
    z-index: 999;
  }
  .logo {
    // margin-top: 1px;
    // margin-left: 25px;
    height: 84px;
    object-fit: contain;
  }
  h1 {
    color: #fff;
    font-size: 21px;
    font-weight: 900;
    text-align: center;
  }
  h2 {
    color: #fff;
    font-size: 12px;
    font-weight: 500;
    text-align: left;
    font-family: Avenir;
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/Layout.vue